import graphqlClient from "../../../apollo";

class UserProvider {

    findUser(id) {
        return graphqlClient.query({
            query: require('./gql/adminUserFind.graphql'),
            variables: { id: id },
            fetchPolicy: "network-only"
        })
    }

    fetchUsers(companyId = null) {
        return graphqlClient.query({
            query: require('./gql/adminUserFetch.graphql'),
            variables: { companyId },
            fetchPolicy: "network-only"
        })
    }

    paginateUsers(companyId = null, pageNumber, itemsPerPage, search = null, orderBy = null, orderDesc = false) {
        return graphqlClient.query({
            query: require('./gql/adminUserPaginate.graphql'),
            variables: { companyId, pageNumber, itemsPerPage, search, orderBy, orderDesc },
            fetchPolicy: "network-only"
        })
    }

    createUser(form) {
        return graphqlClient.mutate({
            mutation: require('./gql/adminUserCreate.graphql'),
            variables: { input: form }
        })
    }

    updateUser(id, form) {
        return graphqlClient.mutate({
            mutation: require('./gql/adminUserUpdate.graphql'),
            variables: { id, input: form }
        })
    }

    toggleActiveUser(id) {
        return graphqlClient.mutate({
            mutation: require('./gql/adminUserToggleActive.graphql'),
            variables: { id }
        })
    }

}

export default new UserProvider()

